import { ChartOptions } from 'chart.js';

export const CostPerRoomChartOptions:  ChartOptions<'line'> = {
    responsive: true, 
    animations: {
        radius: {  
          duration: 600,
          loop: (context) => context.active
        }
      },
      interaction: {
      mode: 'index', 
      intersect: false, 
      axis: 'x' 
    },
    plugins: 
    {
      legend: 
      { 
        display: false,
        labels: 
        {
          font: 
          {
            family: "'Inter', sans-serif",  
            size: 14,                                                  
          },
        },
      },
      datalabels:{
          color: '#899093',
          align: 'top',          
          offset: 2,            
          clip: false, 
          padding: {
            bottom: 20,
            left: 10,
          },
          anchor: 'end',
          font: {
            family: "'Inter', sans-serif",
            size: 12,
          },
        },
      
      tooltip: 
      { 
        enabled: true,
        bodyFont: 
        {
          family: "'Inter', sans-serif",
          size: 14,
        } 
      },
      title: {
      display: true,
      text: 'Cost Per Room',
      font: {
        family: "'Inter', sans-serif",
        size: 16,
        weight: 'bold'
      },
      padding: {
        top: 10, 
        bottom: 30, 
      },
    },
    },
    scales: 
    {
      x: 
      {
        title: 
        {
          display: true,
          text: 'Month',
          font: {
          family: "'Inter', sans-serif",
          size: 14,
          },
        },
        ticks: {
          font: {
            family: "'Inter', sans-serif",
            size: 14,
          },
        },
      },
      y: 
      {
        beginAtZero: true,
        title: 
        {
          display: true,
          text: 'Cost',
          font: {
          family: "'Inter', sans-serif",
          size: 14,
          },
        },
        ticks: {
          font: {
            family: "'Inter', sans-serif",
            size: 14,
          },
        },
      }
    }
  };